import { useState, useEffect } from 'react';
import { getInspectionFilterDates } from '@/utils/inspection.utils';
import { LoadingStatus } from '@/enums/LoadingStatus.enum';
import { setInspectionList } from '@/store/slices/inspectionsSlice';
import { store } from '@/store/store';
import { AppConfig } from '@/types/AppConfig.type';
import { ControlPoint } from '@/types/ControlPoint';

interface UseInspectionFiltersProps {
    config: AppConfig; // Replace with proper config type
    controlPoints: ControlPoint[]; // Replace with proper ControlPoint type
}

export const useInspectionFilters = ({ config, controlPoints }: UseInspectionFiltersProps) => {
    const datesSettings = getInspectionFilterDates(config);

    const [productCode, setProductCode] = useState<string>(() => {
        const savedProductCode = localStorage.getItem('inspectionProductCode');
        return savedProductCode || '';
    });
    const [orderReference, setOrderReference] = useState<string>(() => {
        const savedOrderReference = localStorage.getItem('inspectionOrderReference');
        return savedOrderReference || '';
    });

    const [controlPoint, setControlPoint] = useState<string>(() => {
        const savedControlPoint = localStorage.getItem('inspectionControlPoint');
        return savedControlPoint || '';
    });

    const [startDate, setStartDate] = useState<string>(() => {
        const savedStartDate = localStorage.getItem('inspectionStartDate');
        return savedStartDate || datesSettings.start;
    });

    const [endDate, setEndDate] = useState<string>(() => {
        const savedEndDate = localStorage.getItem('inspectionEndDate');
        return savedEndDate || datesSettings.end;
    });

    const [status, setStatus] = useState<{ controlPoints: LoadingStatus, inspections: LoadingStatus, defectCodes: LoadingStatus }>({ 
        controlPoints: LoadingStatus.IDLE, 
        inspections: LoadingStatus.IDLE,
        defectCodes: LoadingStatus.IDLE
    });


    // Set initial control point when control points are loaded
    useEffect(() => {
        if (controlPoints?.length && !controlPoint) {
            setControlPoint(controlPoints[0]?.id || "");
        }
    }, [controlPoints, controlPoint]);

    const handleProductCodeChange = (productCode: string) => {
        setProductCode(productCode);
        localStorage.setItem('inspectionProductCode', productCode);
    };
    const handleOrderReferenceChange = (orderReference: string) => {
        setOrderReference(orderReference);
        localStorage.setItem('inspectionOrderReference', orderReference);
    };

    const handleControlPointChange = (controlPoint: string) => {
        setControlPoint(controlPoint);
        localStorage.setItem('inspectionControlPoint', controlPoint);
        store.dispatch(setInspectionList([]));
    };

    const handleInspectionStartDateChange = (startDate: string) => {
        setStartDate(startDate);
        localStorage.setItem('inspectionStartDate', startDate);
    };

    const handleInspectionEndDateChange = (endDate: string) => {
        setEndDate(endDate);
        localStorage.setItem('inspectionEndDate', endDate);
    };

    return {
        // State
        productCode,
        orderReference,
        controlPoint,
        startDate,
        endDate,
        status,
        datesSettings,
        
        // Setters
        setStatus,
        
        // Handlers
        handleProductCodeChange,
        handleOrderReferenceChange,
        handleControlPointChange,
        handleInspectionStartDateChange,
        handleInspectionEndDateChange,
    };
}; 